import z from 'zod/v4';
import { SystemProcedure } from '../procedures/system.js';
export var PerformedByType;
(function (PerformedByType) {
    PerformedByType["Key"] = "KEY";
    PerformedByType["User"] = "USER";
    PerformedByType["Workflow"] = "WORKFLOW";
    PerformedByType["Trigger"] = "TRIGGER";
    PerformedByType["VoucherApplication"] = "VOUCHER_APPLICATION";
    PerformedByType["BulkAction"] = "BULK_ACTION";
    PerformedByType["Integration"] = "INTEGRATION";
    PerformedByType["Connect"] = "CONNECT";
    PerformedByType["Import"] = "IMPORT";
    PerformedByType["UpdateTypeOnCaseEnd"] = "UPDATE_TYPE_ON_CASE_END";
    PerformedByType["InteractionCategory"] = "INTERACTION_CATEGORY";
    PerformedByType["AI"] = "AI";
    PerformedByType["PaymentPlan"] = "PAYMENT_PLAN";
    PerformedByType["System"] = "SYSTEM";
})(PerformedByType || (PerformedByType = {}));
export const toPublic = (performedBy) => {
    if (performedBy == null) {
        return performedBy;
    }
    // Only USER and KEY carry ip/requestId by type, but strip on every branch
    // so a stray field on an imported or hand-written row can never leak.
    const { ip: _ip, requestId: _requestId, ...rest } = performedBy;
    return rest;
};
export const user = (id, options = {}) => {
    return {
        type: PerformedByType.User,
        id,
        ip: options.ip,
        requestId: options.requestId,
    };
};
// Extract the user id from a PerformedBy, or undefined when it was not a user.
export const getUserId = (performedBy) => {
    return performedBy != null && performedBy.type === PerformedByType.User
        ? performedBy.id
        : undefined;
};
export const key = (id, options = {}) => {
    return {
        type: PerformedByType.Key,
        id,
        ip: options.ip,
        requestId: options.requestId,
    };
};
export const workflow = (id) => {
    return {
        type: PerformedByType.Workflow,
        id,
    };
};
export const integration = (id) => {
    return {
        type: PerformedByType.Integration,
        id,
    };
};
export const trigger = (id, procedureId) => {
    return {
        type: PerformedByType.Trigger,
        id,
        procedureId,
    };
};
export const voucherApplication = (id) => {
    return {
        type: PerformedByType.VoucherApplication,
        id,
    };
};
export const bulkAction = (id) => {
    return {
        type: PerformedByType.BulkAction,
        id,
    };
};
export const connect = (id) => {
    return {
        type: PerformedByType.Connect,
        id,
    };
};
export const fromImport = (id) => {
    return {
        type: PerformedByType.Import,
        id,
    };
};
export const byUpdateTypeOnCaseEnd = (updateTypeId) => {
    return {
        type: PerformedByType.UpdateTypeOnCaseEnd,
        id: updateTypeId,
    };
};
export const interactionCategory = (id, procedureId) => {
    return {
        type: PerformedByType.InteractionCategory,
        id,
        procedureId,
    };
};
export const ai = (options = {}) => {
    return {
        type: PerformedByType.AI,
        agentRunId: options.agentRunId,
        approvedBy: options.approvedBy,
    };
};
export const aiAgentRun = (args) => ai({
    agentRunId: args.runId,
    approvedBy: args.approvedBy?.type === PerformedByType.User
        ? args.approvedBy.id
        : undefined,
});
export const paymentPlan = (id) => {
    return {
        type: PerformedByType.PaymentPlan,
        id,
    };
};
export const system = (details) => {
    return {
        type: PerformedByType.System,
        details,
    };
};
const IPSchema = z.union([z.ipv4(), z.ipv6()]);
export const PerformedBySchema = z.union([
    z.object({
        type: z.literal(PerformedByType.Key),
        id: z.uuid(),
        ip: IPSchema.optional(),
        requestId: z.uuid().optional(),
    }),
    z.object({
        type: z.literal(PerformedByType.User),
        id: z.uuid(),
        ip: IPSchema.optional(),
        requestId: z.uuid().optional(),
    }),
    z.object({
        type: z.literal(PerformedByType.Workflow),
        id: z.uuid(),
    }),
    z.object({
        type: z.literal(PerformedByType.Trigger),
        id: z.enum(SystemProcedure),
        procedureId: z.uuid(),
    }),
    z.object({
        type: z.literal(PerformedByType.VoucherApplication),
        id: z.uuid(),
    }),
    z.object({
        type: z.literal(PerformedByType.BulkAction),
        id: z.uuid(),
    }),
    z.object({
        type: z.literal(PerformedByType.Integration),
        id: z.uuid(),
    }),
    z.object({
        type: z.literal(PerformedByType.Connect),
        id: z.uuid(),
    }),
    z.object({
        type: z.literal(PerformedByType.Import),
        id: z.uuid(),
    }),
    z.object({
        type: z.literal(PerformedByType.UpdateTypeOnCaseEnd),
        id: z.uuid(),
    }),
    z.object({
        type: z.literal(PerformedByType.InteractionCategory),
        id: z.uuid(),
        procedureId: z.uuid(),
    }),
    z.object({
        type: z.literal(PerformedByType.AI),
        agentRunId: z.uuid().optional(),
        approvedBy: z.uuid().optional(),
    }),
    z.object({
        type: z.literal(PerformedByType.PaymentPlan),
        id: z.uuid(),
    }),
    z.object({
        type: z.literal(PerformedByType.System),
        details: z.string().optional(),
    }),
]);
//# sourceMappingURL=index.js.map